import MyDocumentsFiles from './MyDocumentsFiles';

export default MyDocumentsFiles;
